


























































































import * as R from 'ramda';
import Vue from 'vue';

import { Client } from '@/core/entity';
import CountryInput from '@/vue/components/input/Country.vue';
import CseInput from '@/vue/components/input/Cse.vue';

import { getClientQL } from './graphql';

export default Vue.extend({
  components: {
    'input-country': CountryInput,
    'input-cse': CseInput,
  },

  props: {
    clientId: String as () => string,
    loading: Boolean as () => boolean,
  },

  apollo: {
    client: {
      query: getClientQL,
      variables() {
        return { id: this.clientId };
      },
      skip() {
        return !this.clientId;
      },
      fetchPolicy: 'cache-and-network',
    },
  },

  data() {
    return {
      client: null as Client | null,
      form: this.$form.createForm(this),
    };
  },

  watch: {
    clientId(newVal: string | null) {
      this.client = null;
    },
    client(newVal: Client) {
      this.form.setFieldsValue({
        name: newVal ? newVal.name : '',
        country: newVal ? newVal.country : '',
        picName: newVal ? newVal.picName : '',
        picEmail: newVal ? newVal.picEmail : '',
        cse: newVal ? R.map(R.prop('id'), newVal.cse!) : [],
      });
    },
  },

  methods: {
    handleSubmit() {
      this.form.validateFields((errors: Error[], val: any) => {
        if (errors === null) {
          this.$emit('submit', val);
        }
      });
    },
  },
});
